module.exports = __webpack_public_path__ + "static/media/dan_lee.5bc56f47.png";